import React from 'react'
import PropTypes from 'prop-types'

import pic03 from '../images/pic03.jpg'
import pic04 from '../images/pic04.jpg'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div ref={this.props.setWrapperRef} id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">About</h2>
          <span className="image main"><img src={pic03} alt="" /></span>
<p>バーチャルに生きるヨットセーラー。</p><p>YouTubeやniconicoへの動画投稿、または生放送などでヨットの魅力などをゆるっと伝えていく予定です。乞うご期待！</p>
<p><a href="https://hub.vroid.com/characters/3943351280205481921/models/2820561992715237504" target="_blank" rel="noopener noreferrer"> VRoid Hub</a> で 3D モデルが見れます！(今のところダウンロードは出来ません…)</p>
<a href="https://hub.vroid.com/characters/3943351280205481921/models/2820561992715237504" target="_blank" rel="noopener noreferrer"><img src={pic04} alt="" /></a>
<br />
                   {close}
        </article>

        <article id="contact" className={`${this.props.article === 'contact' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Contact</h2>
         <ul className="icons">
            <li><a href="https://twitter.com/uminek_ooo" className="icon fa-twitter"><span className="label">Twitter</span></a> uminek_ooo</li>
          </ul>

<svg height="38"viewBox="0 0 3000 512">
                            <defs/>
                            <path d="m297.2 243.2c0 15.6-11.5 28.4-26.1 28.4-14.3 0-26.1-12.8-26.1-28.4s11.5-28.4 26.1-28.4 26.1 12.8 26.1 28.4zm-119.5-28.4c-14.6 0-26.1 12.8-26.1 28.4s11.8 28.4 26.1 28.4c14.6 0 26.1-12.8 26.1-28.4 0.3-15.6-11.5-28.4-26.1-28.4zm270.3-162v459.3c-64.5-57-43.9-38.1-118.8-107.8l13.6 47.4h-290.3c-28.9 0-52.5-23.6-52.5-52.7v-346.1c0-29.2 23.6-52.7 52.5-52.7h343c28.9 0 52.5 23.6 52.5 52.7zm-73 242.7c0-82.4-36.9-149.2-36.9-149.2-36.9-27.6-71.9-26.9-71.9-26.9l-3.6 4.1c43.5 13.3 63.7 32.5 63.7 32.5-60.8-33.3-132.2-33.3-191.2-7.4-9.5 4.4-15.1 7.4-15.1 7.4s21.2-20.2 67.3-33.5l-2.6-3.1s-35.1-0.8-71.9 26.9c0 0-36.9 66.8-36.9 149.3 0 0 21.5 37.1 78.1 38.9 0 0 9.5-11.5 17.2-21.2-32.5-9.7-44.8-30.2-44.8-30.2 3.8 2.6 10 6.1 10.5 6.4 43.2 24.2 104.6 32.1 159.7 9 9-3.3 18.9-8.2 29.4-15.1 0 0-12.8 21-46.3 30.5 7.7 9.7 16.9 20.7 16.9 20.7 56.6-1.8 78.3-38.9 78.3-38.9z" fill="#fff"/>
                            <text className="a" fontFamily="sans-serif" fontSize="47px" x="677" y="314.1">
                                    <tspan style={{"fill":"#fff","strokeWidth":"6"}}className="a" fontSize="188px" x="677" y="314.1">uminek.ooo#3714</tspan>
                            </text>
                        </svg>

            <br />
            <br />

            <svg height="24" version="1.1" viewBox="0 0 1614.4 170.55"><g><g transform="translate(-66.192 27.226)"><rect height="152.55" width="493.39" ry="23.457" x="338.18" y="-27.226" fill="#fff"/><g strokeWidth=".41712"><path d="m176.01-10.287-44.156 121.31h-21.508l-44.156-121.31h17.271l38.046 106.72 38.046-106.72z" fill="#fff"/><path d="m294.79 111.02h-20.938l-40.572-48.23h-22.73v48.23h-16.131v-121.31h33.973q10.998 0 18.331 1.4664 7.3322 1.385 13.198 5.0511 6.599 4.1549 10.265 10.509 3.7476 6.2731 3.7476 15.968 0 13.116-6.599 21.997-6.599 8.7986-18.168 13.279zm-37.72-87.172q0-5.214-1.8738-9.206-1.7923-4.0734-6.0287-6.8434-3.5032-2.3626-8.3098-3.2588-4.8067-0.97763-11.324-0.97763h-18.982v45.786h16.294q7.6581 0 13.361-1.3035 5.7028-1.385 9.6948-5.0511 3.6661-3.4217 5.3769-7.821 1.7923-4.4808 1.7923-11.324z" fill="#fff"/><path d="m462.78 102.22q-4.4808 1.9552-8.1469 3.6661-3.5846 1.7108-9.4504 3.5846-4.9696 1.5479-10.835 2.607-5.7843 1.1406-12.791 1.1406-13.198 0-24.033-3.6661-10.754-3.7476-18.738-11.65-7.821-7.7395-12.22-19.634-4.3993-11.976-4.3993-27.781 0-14.99 4.2364-26.803 4.2364-11.813 12.22-19.96 7.7395-7.9025 18.656-12.057 10.998-4.1549 24.359-4.1549 9.7763 0 19.471 2.3626 9.7763 2.3626 21.671 8.3098v19.145h-1.222q-10.021-8.3913-19.878-12.22t-21.1-3.829q-9.206 0-16.62 3.0144-7.3322 2.9329-13.116 9.206-5.6214 6.1102-8.7986 15.479-3.0958 9.2875-3.0958 21.508 0 12.791 3.4217 21.997 3.5032 9.206 8.9616 14.99 5.7028 6.0287 13.279 8.9616 7.6581 2.8514 16.131 2.8514 11.65 0 21.834-3.992 10.184-3.992 19.064-11.976h1.1406z" fill="#000"/><path d="m578.55 111.02h-16.131v-59.391h-60.531v59.391h-16.131v-121.31h16.131v47.578h60.531v-47.578h16.131z" fill="#000"/><path d="m706.86 111.02h-17.19l-11.894-33.81h-52.466l-11.894 33.81h-16.375l44.156-121.31h21.508zm-34.054-47.659-21.263-59.554-21.345 59.554z" fill="#000"/><path d="m802.02 4.0512h-43.341v106.97h-16.131v-106.97h-43.341v-14.339h102.81z" fill="#000"/></g></g></g><text style={{"lineHeight":"1.25"}} fill="#fff" fontFamily="sans-serif" fontSize="105.83px" strokeWidth=".26458" x="900.20538" y="121.85" xmlSpace="preserve"><tspan fontSize="100.41px" strokeWidth=".26458" x="900.20538" y="121.85">uminek.ooo</tspan></text></svg>

<br />
<br />
<p><a href="https://marshmallow-qa.com/uminek_ooo" target="_blank" rel="noopener noreferrer">マシュマロ で質問を送る</a>(<a href="https://twitter.com/uminek_ooo" target="_blank" rel="noopener noreferrer">Twitter</a> にて返信を書くかもです！)</p>
<hr />
<p><h3>お問い合わせフォーム</h3></p>
<form class="formrun" action="https://form.run/api/v1/r/nnu1tx72shlyi72oi3y7mj26" method="post">

            <div className="field half first">

              <label htmlFor="name">お名前(Name)</label>

              <input type="text" name="お名前" id="name" />

            </div>

            <div className="field half">

              <label htmlFor="email">メールアドレス(Email)</label>
    <input name="メールアドレス" type="text" data-formrun-type="email" id="email" />
    <div data-formrun-show-if-error="メールアドレス">メールアドレスを正しく入力してください</div>

            </div>

            <div className="field">

              <label htmlFor="message">お問い合わせ・ご意見・ご感想(Message)[必須]</label>

		 <textarea name="お問い合わせ" data-formrun-required id="message" rows="7" required></textarea>
	    	<div data-formrun-show-if-error="お問い合わせ">お問い合わせを入力してください</div>

            </div>

	  <div>
	    お問い合わせ前に<a href="https://uminek.ooo/policy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>をご確認ください。<br />
	    ご返信が必要なお問い合わせの場合は、メールアドレスをご入力ください。
	  </div>

            <ul className="actions">

              <li><input type="submit" data-formrun-error-text="未入力の項目があります" value="送信(Send)" className="special" /></li>

            </ul>

          </form>


          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
